/* ==========================================================================
   MG STEPS
   Hover / focus / tap a step to make it active: its image cross-fades in
   with a short flash. The active step stays active after the pointer leaves.
   ========================================================================== */
(function () {
  'use strict';

  function mgInitSteps(mgRoot) {
    if (!mgRoot || mgRoot.dataset.mgStepsReady) return;
    mgRoot.dataset.mgStepsReady = 'true';

    var mgSteps = Array.prototype.slice.call(mgRoot.querySelectorAll('[data-mg-step]'));
    var mgImgs = Array.prototype.slice.call(mgRoot.querySelectorAll('[data-mg-step-img]'));
    var mgFlash = mgRoot.dataset.mgFlash === 'false' ? null : mgRoot.querySelector('[data-mg-steps-flash]');
    var mgCurrent = 0;

    function mgActivate(mgIndex, mgWithFlash) {
      if (mgWithFlash && mgFlash) {
        mgFlash.style.transition = 'none';
        mgFlash.style.opacity = '0.4';
        setTimeout(function () {
          mgFlash.style.transition = 'opacity 0.4s ease-out';
          mgFlash.style.opacity = '0';
        }, 60);
      }
      if (mgIndex === mgCurrent) return;
      mgSteps.forEach(function (mgS, mgI) { mgS.classList.toggle('mg-is-active', mgI === mgIndex); });
      mgImgs.forEach(function (mgM, mgI) { mgM.classList.toggle('mg-is-active', mgI === mgIndex); });
      mgCurrent = mgIndex;
    }

    mgSteps.forEach(function (mgStep, mgI) {
      mgStep.addEventListener('mouseenter', function () { mgActivate(mgI, true); });
      mgStep.addEventListener('focus', function () { mgActivate(mgI, true); });
      mgStep.addEventListener('click', function () { mgActivate(mgI, true); });
    });

    mgRoot.mgActivate = mgActivate;
  }

  function mgInitAll(mgScope) {
    (mgScope || document).querySelectorAll('[data-mg-steps]').forEach(mgInitSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mgInitAll(); });
  } else {
    mgInitAll();
  }

  document.addEventListener('shopify:section:load', function (mgEvent) { mgInitAll(mgEvent.target); });
  document.addEventListener('shopify:block:select', function (mgEvent) {
    var mgRoot = mgEvent.target.closest('[data-mg-steps]');
    if (mgRoot && mgRoot.mgActivate) mgRoot.mgActivate(parseInt(mgEvent.target.dataset.mgStep, 10), false);
  });
})();
